// grensesnitt/grid-with-focused-item — enhancement only. The gallery is a
// pure-CSS radio group and works without this file. The one thing CSS cannot
// do is generate document-unique view-transition-names.

const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' )

// Shared across all galleries on purpose — the names must be unique
// document-wide, not per block.
let viewTransitionCounter = 0

document.querySelectorAll( '.grid-with-focused-item__grid' ).forEach( grid => {
  // Mirrors the prefers-reduced-motion guard in the SCSS.
  if ( !document.startViewTransition || prefersReducedMotion.matches ) return

  grid.querySelectorAll( '.item' ).forEach( item => {
    item.style.viewTransitionName = `gallery-item-${ ++viewTransitionCounter }`
  } )

  grid.querySelectorAll( '.item__select input' ).forEach( radio => {
    radio.addEventListener( 'click', e => {
      // Take over the check so it happens inside the transition.
      e.preventDefault()

      const item = e.target.closest( '.item' )

      // Keeps the growing tile on top for the duration.
      item.style.zIndex = 2

      document.startViewTransition( () => {
        e.target.checked = true
        item.style.zIndex = null
      } )
    } )
  } )
} )
